import { TreeviewItem } from "ngx-treeview";
import { FOLDER_TYPE } from "./../../../../../../apps/resource-portal/src/app/constants/app.constant";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Component, OnInit, Input } from "@angular/core";
import { PrivilegeService } from "apps/resource-portal/src/app/services/privilege.service";

@Component({
  selector: "concourse-folder-explorer",
  templateUrl: "./folder-explorer.component.html",
  styleUrls: ["./folder-explorer.component.scss"],
})
export class FolderExplorerComponent implements OnInit {
  @Input("projectId") projectId;
  selectedItem: TreeviewItem;
  reportName: string;
  public routeList = [];
  public selectedRoute = FOLDER_TYPE.SCHEDULES;
  canEdit:boolean = false
  constructor(
    public activeModal: NgbActiveModal,
    private privilegeService: PrivilegeService
  ) {}

  ngOnInit(): void {
    this.routeList = [
      //   {
      //   name: 'Drawings',
      //   type: FOLDER_TYPE.DRAWINGS
      // }
      {
        name: "Schedule",
        type: FOLDER_TYPE.SCHEDULES,
        canEdit:this.privilegeService.userProjectAccess('PRV_SCHEDULE.CREATE',this.projectId)
      },
      {
        name: "Acquisition",
        type: FOLDER_TYPE.ACQUISITIONS,
        canEdit:this.privilegeService.userProjectAccess('PRV_ACQUISITIONS.CREATE',this.projectId)
      },
      {
        name: "Agendas/Meeting Minutes",
        type: FOLDER_TYPE.MEETINGS,
        canEdit:this.privilegeService.userProjectAccess('PRV_AGENDAS/MEETING_MINUTES.CREATE',this.projectId)
      },
      {
        name: "Deliverables",
        type: FOLDER_TYPE.DELIVERABLES,
        canEdit:this.privilegeService.userProjectAccess('PRV_DELIVERABLES.CREATE',this.projectId)
      },
    ];

    //initially set schedule
    this.canEdit = this.privilegeService.userProjectAccess('PRV_SCHEDULE.CREATE',this.projectId) 
  }

  saveToFolder(name) {
    this.activeModal.close({
      type: this.selectedRoute,
      folderId: this.selectedItem?.value,
      reportName: name,
    });
  }

  getFolderData(route) {
    this.selectedRoute = route.type;
    this.canEdit = route.canEdit
  }

  onSelectFolder(folder) {
    this.selectedItem = folder;
  }
}
